import {Disposable, Environment, UploadableMap} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {AttachNovaAgentFileInput, AttachNovaAgentFileMutation} from './__generated__/AttachNovaAgentFileMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// The raw file rides as a Relay `uploadable` (multipart form field `file`), not in `input` — the
// server reads it from the request and streams it to S3 (see AttachNovaAgentFileMutation.js). The
// response carries the refreshed agent so its `files` and, through them, the Files-scope variables
// update by id in the store; the caller also re-runs its on-demand detail fetch to refresh what it
// reads imperatively.
const mutation = graphql`
	mutation AttachNovaAgentFileMutation($input: AttachNovaAgentFileInput!) {
		attachNovaAgentFile(input: $input) {
			agent {
				id
				files {
					fileId
					filename
					variableToken
					processingStatus
					sizeBytes
					mimeType
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<AttachNovaAgentFileInput>,
	onSuccess?: RelayOnCompleted<AttachNovaAgentFileMutation>,
	onError?: RelayOnError,
	uploadables?: UploadableMap
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<AttachNovaAgentFileMutation>(environment, {
		mutation,
		variables,
		uploadables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
